module.exports = __webpack_public_path__ + "img/ceiling-lamp-md.69c2299a.svg";